export default __webpack_public_path__ + "static/media/icon_result_2.4bb9d299.svg";